import JobBenefitsAndPerks from './JobBenefitsAndPerks.container';

export default JobBenefitsAndPerks;
